export const MINIMUM_REVENUE_DESCRIPTION = 'Aanvulling tot minimumbedrag per dag'
export const MINIMUM_REVENUE_CORRECTION_DESCRIPTION = `Correctie ${MINIMUM_REVENUE_DESCRIPTION.toLowerCase()}`

// A top-up (or its correction) to the minimum revenue per day of a customer, it has no specification of its own
export function isMinimumRevenueLine(invoiceLine: {description?: string}) {
    return [MINIMUM_REVENUE_DESCRIPTION, MINIMUM_REVENUE_CORRECTION_DESCRIPTION].includes(invoiceLine.description)
}
